export default __webpack_public_path__ + "static/media/key-shift.5ed9de47.svg";